// extracted by mini-css-extract-plugin
export default {"navTabs":"Shopkeepers_navTabs__Mo+Fs","flexGap":"Shopkeepers_flexGap__0sWY8"};